<!-- 
    https://v.qq.com/x/page/q3207egmfz2.html
cippe精准营销推介会—连续管作业装备工具系列产品专场完整版
https://v.qq.com/x/page/n3207ro77jd.html
cippe精准营销推介会—连续管作业装备工具系列产品专场-杰瑞专场
https://v.qq.com/x/page/d3207eht3pb.html
cippe精准营销推介会—连续管作业装备工具系列产品专场-开场
https://v.qq.com/x/page/i3207thupj4.html
cippe精准营销推介会—连续管作业装备工具系列产品专场-结语
   -->
<template>
  <div class="activityLive">
    <vue-particles
      class="particles"
      color="#fff"
      :particleOpacity="0.7"
      :particlesNumber="120"
      shapeType="circle"
      :particleSize="4"
      linesColor="#fff"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="2"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
      >
      </vue-particles>
    <div class="w">
      <h2>
        <!-- 活动直播 -->
        <div>
          <img :src="hrefurl+'/public/home/title%26bg/homeLive_en.png'" alt=""/>
        </div>
      </h2>
      <div class="liveContent">
        <div class="liveImg">
          <div class="swiper-container" ref="liveSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" @click="()=>{this.webHerf('https://qteogyvzb.sybmkj.com/live/page/211744180?v=1742633520475')}">
              <!-- <div class="swiper-slide" > -->
                <img src="https://cippe.oss-cn-beijing.aliyuncs.com/public/homelive3-1.jpg" alt=""/>
                <div class="mask"></div>
                <div class="triangleContent">
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="swiper-slide" @click="()=>{this.webHerf('http://e.cippe.com.cn/live/index_en')}">
                <img :src="hrefurl+'/public/home/live/homelive1-1_en.jpg'" alt=""/>
                <div class="mask"></div>
                <div class="triangleContent">
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="swiper-slide" @click="()=>{this.webHerf('http://e.cippe.com.cn/live/jzyx_en')}">
                <img :src="hrefurl+'/public/home/live/homelive2-1_en.jpg'" alt=""/>
                <div class="mask"></div>
                <div class="triangleContent">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="introduce">
          <p>
            <span @click="()=>{this.webHerf('http://e.cippe.com.cn/live/index_en')}">more</span>
          </p>
          <ul class="buttonGroup">
            <!-- <li :class="{active:active==0}" @mouseover="swiperPage(1)" > -->
            <li :class="{active:active==0}" @mouseover="swiperPage(1)" @click="()=>{this.webHerf('https://qteogyvzb.sybmkj.com/live/page/211744180?v=1742633520475')}">
              <img src="https://cippe.oss-cn-beijing.aliyuncs.com/public/livebutton3.jpg" alt=""/>
              <!-- <p>cippe展商直播</p> -->
              <p class="buttonTitle">
                <img :src="hrefurl+'/public/home/live/homeButtonTitle3_en.png'" alt=""/>
              </p>
            </li>
            <li :class="{active:active==1}" @mouseover="swiperPage(2)" @click="()=>{this.webHerf('http://e.cippe.com.cn/live/index_en')}">
              <img :src="hrefurl+'/public/home/live/livebutton1.jpg'" alt=""/>
              <!-- <p>cippe精准营销推介会</p> -->
              <p class="buttonTitle">
                <img :src="hrefurl+'/public/home/live/homeButtonTitle2_en.png'" alt=""/>
              </p>
            </li>
            <li :class="{active:active==2}" @mouseover="swiperPage(3)" @click="()=>{this.webHerf('http://e.cippe.com.cn/live/jzyx_en')}">
              <img :src="hrefurl+'/public/home/live/livebutton2.jpg'" alt=""/>
              <!-- <p>现场活动</p> -->
              <p class="buttonTitle">
                <img :src="hrefurl+'/public/home/live/homeButtonTitle1_en.png'" alt=""/>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="recommended">
        <vueSeamless class="" :data="newsList" :class-option="defaultOption" >
          <ul class="liveList">
            <!-- <li class="title">精彩推荐</li> -->
            <li v-for="(item,index) in newsList" :key="index">
              <a :href="item.href" target="_blank">
                <div>
                  <img :src="item.url" alt=""/>
                </div>
                <h5>{{item.corpname_en}}</h5>
              </a>
            </li>
          </ul>
        </vueSeamless>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import vueSeamless from 'vue-seamless-scroll'
import VueParticles from 'vue-particles'
import Swiper from "swiper";
import "swiper/dist/css/swiper.css"
Vue.use(VueParticles)
export default {
  components:{
    vueSeamless,
  },
  data(){
    return{
      play:true,//播放状态 true为播放
      active:1,
      newsList:[
        {
          id:0,
          url:"http://e.cippe.com.cn/public/images/livepic10.jpg",
          name:'cippe连续管作业装备工具系列产品专场',
          corpname_cn:'烟台杰瑞石油服务集团股份有限公司',
          corpname_en:'Jereh',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20201126/jierui.mp4',
        },
        {
          id:1,
          url:"http://e.cippe.com.cn/public/images/livepic04.jpg",
          name:'cippe高压流体系列产品专场',
          corpname_cn:'烟台杰瑞石油服务集团股份有限公司',
          corpname_en:'Jereh',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200710/jierui.mp4',
        },
        {
          id:2,
          url:"http://e.cippe.com.cn/public/images/livepic05.jpg",
          name:'cippe高压流体系列产品专场',
          corpname_cn:'苏州道森钻采设备股份有限公司',
          corpname_en:'Suzhou Douson Drilling&Production Equipment Co.,Ltd',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200710/daosen.mp4',
        },
        {
          id:3,
          url:"http://e.cippe.com.cn/public/images/livepic06.jpg",
          name:'cippe压裂设备推介专场',
          corpname_cn:'中国石化机械四机公司',
          corpname_en:'SJ PETROLEUM MACHINERY CO',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200515/sijichang.mp4',
        },
        {
          id:4,
          url:"http://e.cippe.com.cn/public/images/livepic07.jpg",
          name:'cippe压裂设备推介专场',
          corpname_cn:'宝鸡石油机械有限责任公司',
          corpname_en:'Baoji Oilfield Machinery Co., Ltd. (BOMCO)',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200515/BOMCO.mp4',
        },
        {
          id:5,
          url:"http://e.cippe.com.cn/public/images/livepic08.jpg",
          name:'cippe压裂设备推介专场',
          corpname_cn:'湖北中油科昊机械制造有限公司',
          corpname_en:'Petrokh',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200515/kehao.mp4',
        },
        {
          id:6,
          url:"http://e.cippe.com.cn/public/images/livepic09.jpg",
          name:'cippe压裂设备推介专场',
          corpname_cn:'中国航天科工集团有限公司宏华集团',
          corpname_en:'CASIC Honghua Group',
          href:'https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200515/honghua.mp4',
        },
      ]
    }
  },
  mounted () {
    this.mySwiper = new Swiper(this.$refs.liveSwiper,{
      autoplay:{
        deley:3000,
        disableOnInteraction:false,
      },
      pagination:{
        el:'.swiper-pagination',
        type:'custom',
        renderCustom:(swiper,current,total)=>{
          var addHtml=''
          for (let i = 0; i < total; i++) {
            if (i==(current-1)) {
              this.active = i
              addHtml +='<span class="swiper-pagination-customs swiper-pagination-customs-active list"></span>' 
            }else{
              addHtml +='<span class="swiper-pagination-customs list"></span>'
            }   
          }
          return addHtml
        }
      },
      loop:true,
    })
    this.mySwiper.el.onmouseover =this.swiperStop
    this.mySwiper.el.onmouseout = this.swiperStart
  },
  methods:{
    swiperStop(){
      this.mySwiper.autoplay.stop();
    },
    swiperStart(){
      if(!this.play){
        this.mySwiper.autoplay.start();
      }
    },
    swiperPage(i){
      this.mySwiper.slideTo(i)
    }
  },
  computed:{
    defaultOption () {
      return {
        // step: 1,
        direction: 2,
        limitMoveNum: 7,
        hoverStop: true,
        openWatch: true,
      }
    }
  }
}
</script>
<style scoped>
  .w{
    max-width: 1200px;
    margin: 0 auto;
  }
  .active{
    color: sandybrown;
  }
  .particles{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .activityLive{
    position: relative;
    background: #1158a3 url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/title&bg/homeLiveBg.jpg') no-repeat top center;
    background-size: 100% 100%;
    padding-bottom: 30px;
  }
  .activityLive .w{
    position: relative;
    z-index: 99;
  }
  .activityLive h2{
    font-size: 40px;
    text-align: center;
    padding: 70px 0 50px;
    color: #008baf;
  }
  .activityLive h2>div{
    /* width: 300px; */
    height: 80px;
    overflow: hidden;
    margin: 0 auto;
  }
  .activityLive h2>div img{
    width: auto;
    height: auto;
  }
  .liveContent{
    height: 500px;
    padding: 30px 20px 20px;
    background-color: rgba(0, 0, 0, .4);
  }
  .liveImg{
    width: 70%;
    height: 450px;
    margin-right: 30px;
    display: inline-block;
    overflow: hidden;
  }
  .liveImg>>>.swiper-container{
    height: 100%;
    /* background-color: pink; */
  }
  .liveImg>>>.swiper-slide{
    cursor: pointer;
  }
  .triangleContent{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 70px;
    height: 70px;
    padding: 15px;
    padding-left: 23px;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 50%;
  }
  .triangle{
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-right: 0px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 32px solid #008baf;
  }
  .mask{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
  }
  .liveImg>>>.list{
    color: royalblue;
  }
  .chainContent{
    width: 100%;
    height: 500px;
    margin: auto;
  }
  .chian{
    width: 100%;
    height: 100%
  }
  .introduce{
    width: calc(30% - 30px);
    display: inline-block;
    color: white;
    vertical-align: top;
    height: 100%;
    position: relative;
  }
  h3{
    font-size: 22px;
    margin-bottom: 30px;
    line-height: 40px;
  }
  h6{
    font-size: 16px;
    font-weight: 600;
  }
  .introduce a{
    background-color: #e7a100;
    border-radius: 15px;
    text-align: center;
    color: #ffffff;
    padding: 5px 20px;
  }
  .introduce>p{
    position: absolute;
    display: inline-block;
    line-height: 1;
    vertical-align: top;
    width: 100%;
    text-align: end;
    right: 0;
    top: -20px;
  }
  .introduce>p span{
    cursor: pointer;
    padding-bottom: 2px;
    font-family: 'FjallaOne-Regular';
  }
  .introduce>p span:hover{
    border-bottom: 1px solid white;
  }
  .introduce .buttonGroup{
    height: 100%;
    text-align: center;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .introduce .buttonGroup li{
    position: relative;
    height: 134px;
    color: white;
    background-color: #008baf;
    overflow: hidden;
  }
  .introduce .buttonGroup li img{
    object-fit: cover;
  }
  .buttonGroup li .buttonTitle img{
    object-fit: contain;
  }
  .introduce .buttonGroup li p{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    line-height: 134px;
    font-size: 28px;
    background-color: rgba(0, 0, 0, .5);
    transition: all .5s;
    cursor: pointer;
  }
  .introduce .buttonGroup li p:hover{
    background-color: rgba(0,139,175, .3);
  }
  /* 推荐列表 */
  .recommended{
    max-height: 278px;
    width: 100%;
    padding: 20px;
    background-color: rgba(0, 0, 0, .8);
  }
  .recommended>div{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }
  .liveList{
    display: inline-block;
    font-family: 'FjallaOne-Regular';
  }
  .liveList li{
    display: inline-block;
    text-align: center;
    padding-left: 20px;
    width: 270px;
    box-sizing: border-box;
  }
  h5{
    color: white;
    font-size: 12px;
    padding: 6px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>